export default {
  title_1: "F.A.Q.".toUpperCase(),
  title_2: "узнайТЕ больше о VisioN.".toUpperCase(),
  important: "важное".toUpperCase(),
  all_answers: "все ответы".toUpperCase(),
  text: "Узнайте всё о Vision в одном месте. Объясняем по фактам, без воды и демагогии.".toUpperCase(),
}
